import _ from 'lodash';
import { PatchResourcesBody } from '../types';

const CHUNK_SIZE = 10;

const mapGroupedItemsToChunks = (key: string) => (groupedItem: any) => {
  if (_.isEmpty(groupedItem)) return [];
  const firstItem = _.first(groupedItem);
  const existingInstanceId = _.get(firstItem, `mapping.${key}.existingInstanceId`, '');
  const newInstanceId = _.get(firstItem, `mapping.${key}.newInstanceId`, '');

  return _(groupedItem)
    .flatMap(({ operation_ids }) => operation_ids)
    .chunk(CHUNK_SIZE)
    .map((chunk) => ({
      existingInstanceId,
      newInstanceId,
      operation_ids: chunk,
    }))
    .value();
};

const groupInstances = (
  list: PatchResourcesBody[],
  key: string,
  autoMappingEnabled = false,
): PatchResourcesBody[] =>
  _(list)
    .groupBy(`mapping.${key}.existingInstanceId`)
    .map(mapGroupedItemsToChunks(key))
    .flatten()
    .map(({ operation_ids, existingInstanceId, newInstanceId }) => ({
      operation_ids,
      mapping: {
        [key]: {
          [existingInstanceId]: newInstanceId,
        },
      },
      auto_mapping_enabled: autoMappingEnabled,
    }))
    .value();

export { groupInstances, mapGroupedItemsToChunks };
